/**
 * Normalize Indian mobile for forms.
 * Typing: keep the first 10 digits (do not drop leading digits).
 * Paste/autofill: strip +91 / 91 only when the value is a full country-code number.
 */
export function normalizeIndianMobileDigits(value) {
  let digits = String(value ?? '').replace(/\D/g, '');
  if (!digits) return '';

  if (digits.startsWith('91') && digits.length >= 12) {
    digits = digits.slice(2);
  } else if (digits.startsWith('0') && digits.length === 11) {
    digits = digits.slice(1);
  }

  return digits.slice(0, 10);
}

/** Alias used by booking / contact forms on each keystroke or blur. */
export function sanitizePhoneInput(value) {
  return normalizeIndianMobileDigits(value);
}

/** Digits only for numeric fields (pincode, etc.) — not phone numbers. */
export function sanitizeNumericNonPhone(value, maxDigits = 12) {
  const d = String(value ?? '').replace(/\D/g, '');
  if (!maxDigits || d.length <= maxDigits) return d;
  return d.slice(0, maxDigits);
}
